<ng-container [ngSwitch]="status">
  <span class="badge badge-short badge-primary" *ngSwitchCase="ORDER_LINE_STATUSES.NEW"
        [translate]="'orderLineBadgeStatuses.new'">New</span>
  <span class="badge badge-short badge-warning" *ngSwitchCase="ORDER_LINE_STATUSES.EDITED"
        [translate]="'orderLineBadgeStatuses.edited'">Edited</span>
  <span class="badge badge-short badge-danger" *ngSwitchCase="ORDER_LINE_STATUSES.DELETED"
        [translate]="'orderLineBadgeStatuses.deleted'">Deleted</span>
</ng-container>
